import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { SoundToggle } from "./components/SoundToggle";
import { CallSalesButton } from "./components/CallSalesButton";
import { InstallPrompt } from "./components/InstallPrompt";
import { PricingTicker } from "./components/PricingTicker";
import { GlobalSourcing } from "./components/GlobalSourcing";
import { QualityAssurance } from "./components/QualityAssurance";
import { IronLogistics } from "./components/IronLogistics";
import { ByteCredit } from "./components/ByteCredit";
import { FoundingTeam } from "./components/FoundingTeam";
import { IronByteWay } from "./components/IronByteWay";
import { HowItWorks } from "./components/HowItWorks";
import { SteelShowcase } from "./components/SteelShowcase";
import { RapidSection } from "./components/RapidSection";
import { TrustSignals } from "./components/TrustSignals";
import { QuoteForm } from "./components/QuoteForm";
import { Footer } from "./components/Footer";
import { FluidCursor } from "./components/FluidCursor";
import { ChatWidget } from "./components/ChatWidget";
import AuthPage from "./pages/AuthPage";
import MarketplacePage from "./pages/MarketplacePage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AdminDashboard from "./pages/AdminDashboard";
import PriceSheetPage from "./pages/PriceSheetPage";
import { Toaster } from "./components/ui/sonner";

function LandingPage({ isDark }) {
  return (
    <>
      <FluidCursor />
      <SoundToggle />
      <HeroSection isDark={isDark} />
      <PricingTicker />
      <IronByteWay />
      <SteelShowcase />
      <HowItWorks />
      <GlobalSourcing />
      <RapidSection />
      <QualityAssurance />
      <IronLogistics />
      <ByteCredit />
      <TrustSignals />
      <FoundingTeam />
      <QuoteForm />
    </>
  );
}

function App() {
  const [isDark, setIsDark] = useState(() => localStorage.getItem("ib-theme") !== "light");
  const toggleTheme = () => setIsDark((prev) => !prev);
  useEffect(() => {
    document.documentElement.classList.toggle("light-mode", !isDark);
    localStorage.setItem("ib-theme", isDark ? "dark" : "light");
  }, [isDark]);

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className={isDark ? "" : "light-mode"} data-testid="app-root">
          <Navbar isDark={isDark} onToggleTheme={toggleTheme} />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage isDark={isDark} />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/marketplace/:id" element={<ProductDetailPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/prices" element={<PriceSheetPage />} />
            </Routes>
          </main>
          <Footer />
          <InstallPrompt />
          <CallSalesButton />
          <ChatWidget />
          <Toaster position="top-right" theme={isDark ? "dark" : "light"} />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
